import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer>
      <h4>Copyright 2022 &#169; tramnguyenhere</h4>
    </footer>
  );
};

export default Footer;
